var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.961 3.696c.365-.74.963-.74 1.328 0l1.687 3.415c.365.74 1.331 1.443 2.148 1.56l3.768.548c.817.12 1 .688.41 1.264l-2.727 2.658c-.591.577-.96 1.713-.822 2.527l.644 3.753c.14.813-.345 1.164-1.075.78l-3.371-1.772c-.73-.382-1.925-.382-2.655 0l-3.372 1.773c-.73.384-1.214.033-1.074-.78l.643-3.754c.14-.814-.23-1.95-.82-2.527l-2.726-2.658c-.59-.576-.406-1.143.41-1.263l3.77-.547c.816-.119 1.783-.821 2.148-1.56l1.686-3.416v-.001z"}));
}

Star.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Star;

Star.default = Star;
